import { render } from "./SkuSalesReportView.vue?vue&type=template&id=45cf39d7&scoped=true"
import script from "./SkuSalesReportView.vue?vue&type=script&lang=js"
export * from "./SkuSalesReportView.vue?vue&type=script&lang=js"

import "./SkuSalesReportView.vue?vue&type=style&index=0&id=45cf39d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf39d7"]])

export default __exports__